'use client';

import React from 'react';
import styled from '@emotion/styled';
import { size, breakpoints } from "@argo/principles";
import { Link } from "@argo/ui-elements";
import { GLOBALNAV_KBB_BASE_URL } from '../../mykbb/utils/constants';
const SocialBase = styled('div')`
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  width: 100%;
  ${props => props.enableOneTrust ? '' : `margin: 0 0 ${size.md}px 0;`}

  @media (min-width: ${breakpoints.md}px) {
    width: 60%;
  }

  @media (min-width: 1200px) {
    width: 30%;
    margin: 0;
  }

  > a {
    height: 48px;
    padding: 12px;
  }

  > a:hover {
      cursor: pointer;
  }

  span {
    margin: 0 ${size.micro}px 0 0;
  }

  > a:last-child > svg {
    width: 60px;
  }
`;
const Social = ({
  links,
  enableOneTrust
}) => React.createElement(SocialBase, {
  enableOneTrust: enableOneTrust
}, links && links.map((link, i) => React.createElement(Link, {
  key: i,
  href: `${GLOBALNAV_KBB_BASE_URL}${link.url}`,
  "data-partner": link.dataPartner,
  "data-automation": link.omnitureTag,
  "data-tag-id": `socialLinks${i}`,
  alt: link.altText,
  target: "_blank",
  rel: "noopener",
  "aria-label": link.ariaLabel
}, link.icon)));
Social.displayName = 'Social';
export default Social;